module.exports = __webpack_public_path__ + "tables2.png?6e1b26f48a0a4d493bc1d10d3b0c620a";